<template>
  <div
    v-if="lawyerList"
    class="main">
    <module-title :module-title="moduleTitle"/>
    <div class="laywer-list double-between">
      <div v-for="(item, index) in arr" :key="index">
        <div v-if="index < 3" class="laywer-list-item" @click="goLawyer">
          <div class="address">上海</div>
          <div class="logo">
            <img src="https://cdn.51ljb.cn/ljb_icons_service_logo.png">
          </div>
          <div class="name">杨洋</div>
          <div class="year">执业12年</div>
          <div class="service">债券债务、婚姻继承</div>
          <div class="button">
            <img src="https://cdn.51ljb.cn/ljb_icons_service_zx.png">
            咨询
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitleNew'
import {mapGetters} from 'vuex'
let namespce = 'Channel'
export default {
  name: 'ListService',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '热门律师',
        text: '查看更多 >',
        url: 'Lawyer'
      },
      arr: [1, 2, 3, 4]
    }
  },
  computed: {
    ...mapGetters(namespce, ['getChannelData']),
    lawyerList () {
      if (this.getChannelData) {
        if (this.getChannelData.activity && Object.keys(this.getChannelData.activity).length > 0) {
          return this.getChannelData.activity
        }
      }
      return null
    }
  },
  methods: {
    goDoc: function (item) {
      this.$utils.checkCanGoRouter(item.url)
    },
    goLawyer() {
      this.$router.push('Lawyer')
    },
  }
}
</script>

<style lang="scss" scoped>
  .main{
    // margin-top: $margin;
    background: #fff;
    padding-bottom: $padding;
  }
  .laywer-list{
    padding:0 $padding 0 $padding;
    box-sizing:  border-box;
    .laywer-list-item{
      width: 108px;
      height: 170px;
      background: linear-gradient(180deg, #FFF4DD 0%, #FEECC9 100%);
      border-radius: 5px;
      position: relative;
      .address{
        width: 41px;
        height: 22px;
        background: linear-gradient(180deg, #FEF8E9 0%, #FFE4B0 100%);
        border-radius: 0px 0px 2px 0px;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #B98727;
      }
      .logo{
        width: 50px;
        height: 50px;
        border-radius: 25px;
        overflow: hidden;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        color: #89631B;
        margin-top: 50px;
      }
      .year{
        font-size: 12px;
        color: #89631B;
        margin-top: 1px;
        text-align: center;
      }
      .service{
        font-size: 8px;
        color: #89631B;
        margin-top: 1px;
        text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .button{
        width: 75px;
        height: 28px;
        background: #FFFBF2;
        border-radius: 28px;
        margin: 6px auto 0;
        text-align: center;
        line-height: 28px;
        >img{
          vertical-align: middle;
          margin-top: -2px;
          width: 14px;
          height: 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/list/ListLawyer.vue